import { createSlice } from "@reduxjs/toolkit";
import { fetchUserData, login } from "./authThunk";
import { toast } from "react-toastify";
import { startExamActivity } from "../../activityAsyncAction";

const initialState = {
  token: null,
  loading: false,
  userData: null,
  repeatTimeOutId: null,
  loginCount: 0, // This can be used to track the number of login attempts
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout: (state) => {
      state.token = null;
      state.userData = null;
      // state.loginController = null;
    },
    setRepeatTimeOut: (state, action) => {
      if (state.repeatTimeOutId) {
        clearTimeout(state.repeatTimeOutId);
      }
      state.repeatTimeOutId = action.payload;
    },
    resetLoginCount: (state) => {
      state.loginCount = 0; // Reset login count
    },
  },
  extraReducers: (builder) => {
    builder.addCase(login.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(login.fulfilled, (state, action) => {
      const { message, token, data } = action.payload;
      console.log(action.payload);
      state.token = token;
      state.userData = data?.candidate;
      state.loading = false;
      if (!token) {
        state.loginCount += 1; // Increment login count on successful login
      }
      if (!state.repeatTimeOutId) {
        toast.success(message);
      }
    });
    builder.addCase(login.rejected, (state, action) => {
      state.loading = false;
      toast.error(action.payload);
    });
    builder.addCase(fetchUserData.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(fetchUserData.fulfilled, (state, action) => {
      const { user } = action.payload;
      state.userData = user;
    });
    builder.addCase(fetchUserData.rejected, (state, action) => {
      state.loading = false;
      state.userData = null;
    });
    builder.addCase(startExamActivity.fulfilled, (state, action) => {
      const { token } = action.payload;
      state.token = token;
    });
  },
});

export const { logout, setRepeatTimeOut, resetLoginCount } = authSlice.actions;

export default authSlice.reducer;
